// extracted by mini-css-extract-plugin
export default {"list":"R48l1J","item":"fGQaI3","link":"afhuBi","message":"ZlkxRP","text":"SwUB5x"};